import {connect} from '@gisatcz/ptr-state';
import Action from '../../../../state/Action';
import Presentation from './presentation';

const mapStateToProps = () => {
	return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		setMapView: place => {
			dispatch(Action.unhab.updateMapView(ownProps.mapKey, place));
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Presentation);
